import type { MinorStats } from "./types.ts";

export const emptyMinorStats = (season: number): MinorStats => ({
	season,
	g: 0,
	pa: 0,
	ab: 0,
	h: 0,
	d: 0,
	t: 0,
	hr: 0,
	bb: 0,
	so: 0,
	rbi: 0,
	gp: 0,
	gs: 0,
	outs: 0,
	bf: 0,
	soP: 0,
	er: 0,
	ha: 0,
	bbA: 0,
	w: 0,
	l: 0,
});

// Derived lines. No HBP/SF in the minors model, so OBP = (H + BB) / PA.
export const minorLine = (s: MinorStats) => {
	const tb = s.h + s.d + 2 * s.t + 3 * s.hr;
	const avg = s.ab > 0 ? s.h / s.ab : 0;
	const obp = s.pa > 0 ? (s.h + s.bb) / s.pa : 0;
	const slg = s.ab > 0 ? tb / s.ab : 0;
	const ip = s.outs / 3;
	return {
		g: s.g,
		pa: s.pa,
		h: s.h,
		hr: s.hr,
		rbi: s.rbi,
		avg,
		ops: obp + slg,
		gp: s.gp,
		outs: s.outs,
		// Baseball notation: 45.2 = 45 innings and 2 outs
		ip: Math.floor(s.outs / 3) + (s.outs % 3) / 10,
		soP: s.soP,
		w: s.w ?? 0,
		l: s.l ?? 0,
		era: ip > 0 ? (9 * s.er) / ip : 0,
		whip: ip > 0 ? (s.ha + s.bbA) / ip : 0,
	};
};
